export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { slug: 'korean-romance', name: '韩国恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的韩国恋爱漫画，心动剧情不容错过' },
  { slug: 'korean-fantasy', name: '韩国奇幻', icon: 'ri-magic-line', description: '充满想象力的韩国奇幻漫画，异世界冒险之旅' },
  { slug: 'korean-action', name: '韩国动作', icon: 'ri-sword-line', description: '热血沸腾的韩国动作漫画，精彩打斗场面' },
  { slug: 'korean-drama', name: '韩国剧情', icon: 'ri-emotion-line', description: '深度剧情的韩国漫画，引人入胜的故事线' },
  { slug: 'japanese-romance', name: '日本恋爱', icon: 'ri-heart-add-line', description: '经典日本恋爱漫画，青春校园纯爱故事' },
  { slug: 'japanese-shounen', name: '日本少年', icon: 'ri-fire-line', description: '热血少年漫画，友情努力胜利的经典主题' },
  { slug: 'chinese-romance', name: '国产恋爱', icon: 'ri-star-line', description: '优质国产恋爱漫画，贴近生活的甜蜜故事' },
  { slug: 'completed', name: '已完结', icon: 'ri-check-double-line', description: '全部已完结漫画，一口气看到结局' },
];

export const categoryMap: Record<string, Category> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});